"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMembershipLocalstorage = setMembershipLocalstorage;
var aov_helper_const_1 = require("@src/const/aov-helper.const");
var input_output_helper_const_1 = require("@src/const/input-output-helper.const");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
function setMembershipLocalstorage(selectedOffering, selectedTerm) {
    var _a, _b, _c;
    var mappings = [
        {
            key: input_mapping_const_1._AllMappings.rateBundleStartDate,
            value: selectedTerm === null || selectedTerm === void 0 ? void 0 : selectedTerm.defaultContractStartDate,
        },
        {
            key: input_mapping_const_1._AllMappings.preuseDate,
            value: (selectedTerm === null || selectedTerm === void 0 ? void 0 : selectedTerm.contractStartDateOfUse) ? selectedTerm === null || selectedTerm === void 0 ? void 0 : selectedTerm.contractStartDateOfUse : null,
        },
        {
            key: input_mapping_const_1._AllMappings.rateBundleAOV,
            value: JSON.stringify((0, aov_helper_const_1._CalculateAOV_V2)(selectedTerm)),
        },
        {
            key: input_mapping_const_1._AllMappings.rateBundleTermDuration,
            value: "".concat(selectedTerm.termValue, " ").concat(selectedTerm.termUnit),
        },
        { key: input_mapping_const_1._AllMappings.rateBundleName, value: selectedOffering.name },
        { key: input_mapping_const_1._AllMappings.rateBundleTermId, value: selectedTerm.id },
        { key: input_mapping_const_1._AllMappings.rateBundlePrice, value: selectedTerm.price },
        {
            key: input_mapping_const_1._AllMappings.rateBundleTermValue,
            value: selectedTerm.termValue,
        },
        {
            key: input_mapping_const_1._AllMappings.isOnetimePayment,
            value: (((_a = selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.modules) === null || _a === void 0 ? void 0 : _a.find(function (mod) { return mod.name.toLowerCase() === 'onetimepayment'; })) !== undefined).toString(),
        },
        {
            key: input_mapping_const_1._AdditionalFields.contractDescription,
            value: (_b = selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.description) !== null && _b !== void 0 ? _b : '',
        },
        {
            key: input_mapping_const_1._AdditionalFields.contractSubdescription,
            value: (_c = selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.subDescription) !== null && _c !== void 0 ? _c : '',
        },
    ];
    mappings.forEach(function (_a) {
        var key = _a.key, value = _a.value;
        if (value !== null && value !== undefined) {
            (0, input_output_helper_const_1._SaveFieldInLocalstorage)(key, value);
        }
    });
    // extra membershipid
    (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AdditionalContractFieldsMapping.membershipId, selectedOffering.id);
}
